module.exports = __webpack_public_path__ + "img/email-marketing.b63ccf67.jpg";